<script>
    import jQuery from "jquery";
    import {GPContextCloner} from "./gp-context-cloner.js";
    import {getGPTransFunc} from "./gp-translations";
    let trans = getGPTransFunc("gp-cloner");

</script>

<div>
    <p>
        {trans("You can remove a plant from the picture by cloning part of a background")}.
        {trans("Click beside unwanted object, then paint over it")}.
        {trans("To reset the cloning offset, click the crosshair button below and start over")}.
    </p>
</div>